import { useMemo } from 'react'
import { useSelector } from 'store/hooks/useSelector'
import { decodeRolesFromToken, type Role } from 'auth/roles'

export function useUserRoles(): string[] {
  const accessToken = useSelector((state) => state.auth.accessToken)
  return useMemo(() => decodeRolesFromToken(accessToken), [accessToken])
}

export function useHasRole(role: Role): boolean {
  const roles = useUserRoles()
  return roles.includes(role)
}
